module.exports = __webpack_public_path__ + "static/media/ic_incident.182bca85.svg";